const redirectUrl = (): void => {
  const { search } = window.location
  let url
  const href = encodeURIComponent(window.location.href)
  if (search) {
    url = `${search}&redirect_url=${href}`
  } else {
    url = `?redirect_url=${href}`
  }
  window.location.href = import.meta.env.VITE_APP_H5_USER_LOGIN_URL + url
}

export default redirectUrl
